export const AutheErrorMessage = (statusCode: number, errorResponse?: any, context?: string): string => {
    // Check if there's a validation error in the response
    if (errorResponse && errorResponse.message) {
        try {
            // Check if the message contains a JSON string with validation errors
            if (typeof errorResponse.message === 'string' && errorResponse.message.includes('{')) {
                const validationErrors = JSON.parse(errorResponse.message.substring(
                    errorResponse.message.indexOf('{'),
                    errorResponse.message.lastIndexOf('}') + 1
                ));
                
                // Handle specific validation errors for id_number based on context
                if (validationErrors.id_number) {
                    // Check for various "already taken" error message patterns in English
                    const errorMsg = validationErrors.id_number.toString().toLowerCase();
                    if (errorMsg.includes('already been taken') || 
                        errorMsg.includes('already taken') || 
                        errorMsg.includes('already exists') ||
                        errorMsg.includes('already in use') ||
                        errorMsg.includes('must be unique')) {
                        
                        // Return context-specific messages for duplicate ID numbers
                        switch (context) {
                            case 'distributor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro distribuidor';
                            case 'doctor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro médico';
                            case 'institution':
                                return 'El DNI/CUIT ingresado ya está registrado para otra institución';
                            case 'manufacturer':
                                return 'El DNI/CUIT ingresado ya está registrado para otro fabricante';
                            case 'client':
                                return 'El DNI/CUIT ingresado ya está registrado para otro cliente';
                            case 'user':
                                return 'El DNI ingresado ya está registrado para otro usuario';
                            default:
                                return 'El DNI/CUIT ingresado ya está registrado en el sistema';
                        }
                    }
                }
                
                // Return the first validation error message if available
                for (const field in validationErrors) {
                    if (validationErrors[field] && validationErrors[field].length > 0) {
                        // Translate common validation error messages
                        const errorMsg = validationErrors[field][0].toString().toLowerCase();
                        
                        if (errorMsg.includes('already been taken') || 
                           errorMsg.includes('already taken') || 
                           errorMsg.includes('already exists') ||
                           errorMsg.includes('already in use') ||
                           errorMsg.includes('must be unique')) {
                            if (field === 'email') {
                                return 'El correo electrónico ingresado ya está registrado en el sistema';
                            } else if (field === 'id_number') {
                                return 'El DNI/CUIT ingresado ya está registrado en el sistema';
                            } else {
                                return `El campo ${field} ya está en uso`;
                            }
                        }
                        
                        // If it's another type of error, return it (could be translated in future)
                        return `Error de validación: ${validationErrors[field][0]}`;
                    }
                }
            } else if (typeof errorResponse.message === 'string') {
                // Direct message without JSON structure
                const message = errorResponse.message.toLowerCase();
                
                // Check for common error patterns and translate them
                if (message.includes('already been taken') || 
                    message.includes('already taken') || 
                    message.includes('already exists') ||
                    message.includes('already in use') ||
                    message.includes('must be unique')) {
                    
                    if (message.includes('id_number') || message.includes('dni') || message.includes('cuit')) {
                        switch (context) {
                            case 'distributor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro distribuidor';
                            case 'doctor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro médico';
                            case 'institution':
                                return 'El DNI/CUIT ingresado ya está registrado para otra institución';
                            case 'manufacturer':
                                return 'El DNI/CUIT ingresado ya está registrado para otro fabricante';
                            case 'client':
                                return 'El DNI/CUIT ingresado ya está registrado para otro cliente';
                            case 'user':
                                return 'El DNI ingresado ya está registrado para otro usuario';
                            default:
                                return 'El DNI/CUIT ingresado ya está registrado en el sistema';
                        }
                    } else if (message.includes('email')) {
                        return 'El correo electrónico ingresado ya está registrado en el sistema';
                    }
                }
                
                // Return the original message if no translation is available
                return `Error de validación: ${errorResponse.message}`;
            }
        } catch (e) {
            // If parsing fails, try to analyze the raw message
            if (typeof errorResponse.message === 'string') {
                const message = errorResponse.message.toLowerCase();
                
                // Check for common error patterns and translate them
                if (message.includes('already been taken') || 
                    message.includes('already taken') || 
                    message.includes('already exists') ||
                    message.includes('already in use') ||
                    message.includes('must be unique')) {
                    
                    if (message.includes('id_number') || message.includes('dni') || message.includes('cuit')) {
                        switch (context) {
                            case 'distributor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro distribuidor';
                            case 'doctor':
                                return 'El DNI/CUIT ingresado ya está registrado para otro médico';
                            case 'institution':
                                return 'El DNI/CUIT ingresado ya está registrado para otra institución';
                            case 'manufacturer':
                                return 'El DNI/CUIT ingresado ya está registrado para otro fabricante';
                            case 'client':
                                return 'El DNI/CUIT ingresado ya está registrado para otro cliente';
                            case 'user':
                                return 'El DNI ingresado ya está registrado para otro usuario';
                            default:
                                return 'El DNI/CUIT ingresado ya está registrado en el sistema';
                        }
                    } else if (message.includes('email')) {
                        return 'El correo electrónico ingresado ya está registrado en el sistema';
                    }
                }
            }
            
            // If all else fails, continue with the default error handling
            console.error('Error parsing validation message:', e);
        }
    }
    
    // Default status code based messages
    const options: Record<number, string> = {
        401: 'Credenciales inválidas. Vuelva a intentarlo nuevamente.',
        422: 'Error de validación en los datos enviados. Por favor, revise la información ingresada.',
    }
    return options[statusCode] ?? 'Hubo un problema al procesar su solicitud. Vuelva a intentarlo más tarde.';
}